import React, { useState } from "react";
import * as contributorApi from "../../../../api/contributorApi";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  getMindfile,
} from "../../../../state/actions/getDataActions";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Modal,
  ListSubheader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@material-ui/core/";
import Alert from "@material-ui/lab/Alert";
import CreateMindfileForm from "./CreateMindfileForm";
import NotificationsList from "./NotificationsList";
import MindfileAvatar from "./MindfileAvatar";

const useStyles = makeStyles(() => ({
  root: {
    position: "static",
    transform: "translateZ(0)",
    display: 'flex',
    height:'64px'
  },
  toolbarLeft:{
    display:'flex',
    height:'100%',
    alignItems:'center'
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

function MindfileBar({ user, mindfile, mindfiles, getMindfile }) {
  const classes = useStyles();
  const history = useHistory();

  const [isCreateMindfileOpen, setIsCreateMindfileOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [isContributorRequestOpen, setIsContributorRequestOpen] = useState(
    false
  );

  const isContributor = () => {
    if (mindfile && mindfile.contributors) {
      if (
        mindfile.contributors.find(contributor => contributor.id === user.uid)
      ) {
        if (user.mid !== mindfile.id) {
          return true;
        }
      }
    }
  };

  const userId = user.uid ? user.uid : null;
  const mindfileOwnerId = mindfile.owner ? mindfile.owner : null;

  const getMindfileName = mindfile => {
    const mindfileContributorIds = mindfile.contributors
      ? mindfile.contributors.map(item => item.id)
      : [];
    const mindfileOwnerId = mindfile.owner ? mindfile.owner : null;
    let userType = "";
    if (userId && mindfileOwnerId) {
      if (user.mid === mindfile.id) {
        userType = "(owner)";
      } else if (userId === mindfileOwnerId) {
        userType = "(editor)";
      } else if (mindfileContributorIds.includes(userId)) {
        userType = "(contributor)";
      }
    }
    return mindfile.name ? `${mindfile.name} ${userType}` : "";
  };

  const getRootStyle = () => {
    const rootClasses = [];
    if (userId && mindfileOwnerId) {
      rootClasses.push(classes.root);
      if (userId === mindfileOwnerId) {
      }
    }
    return rootClasses.join(" ");
  };

  const handleChange = e => {
    if (e.target.value === "create_new") {
      setIsCreateMindfileOpen(true);
    } else if (e.target.value === "become_contributor") {
      contributorApi.requestToBecomeContributor(
        mindfile.id,
        user.authenticity_token
      );
      setIsContributorRequestOpen(true);
    } else {
      getMindfile(e.target.value, () => history.push("/explore"));
    }
  };

  const renderNotificationsToggle = () => {
    let notificationsCount = 0;

    if (
      mindfile.hasOwnProperty("invitations_received") &&
      mindfile.invitations_received.length
    ) {
      notificationsCount += mindfile.invitations_received.length;
    }

    if (mindfile.hasOwnProperty("requests") && mindfile.requests.length) {
      notificationsCount += mindfile.requests.length;
    }

    if (notificationsCount) {
      let notificationText = "1 notification";
      if (notificationsCount > 1) {
        notificationText = `${notificationsCount} notifications`;
      }
      return (
        <Alert
          id="mindfileNotifications"
          severity="info"
          onClick={() => setIsNotificationsOpen(true)}
          style={{ cursor: "pointer" }}
        >
          {notificationText}
        </Alert>
      );
    } else {
      return null;
    }
  };

  const renderMindfileSelector = () => {
    return (
      <FormControl style={{ minWidth: 150 }}>
        <Select id="selectedViewingMindfile" value="current_mindfile" onChange={handleChange}>
          <ListSubheader className={classes.listSubHeader}>
            Current Mindfile
          </ListSubheader>
          <MenuItem value="current_mindfile">
            {getMindfileName(mindfile)}
          </MenuItem>
          {mindfile.group && !isContributor()  && mindfile.owner !== user.uid ? (
            <MenuItem value="become_contributor">Become a contributor</MenuItem>
          ) : null}

          <ListSubheader className={classes.listSubHeader}>
            My Mindfiles
          </ListSubheader>
          {mindfiles.map(mindfile => {
            return (
              <MenuItem key={mindfile.id} value={mindfile.id}>
                {getMindfileName(mindfile)}
              </MenuItem>
            );
          })}
          <ListSubheader className={classes.listSubHeader}>
            Actions
          </ListSubheader>
          <MenuItem value="create_new">Create another mindfile</MenuItem>
        </Select>
      </FormControl>
    );
  };

  return (
    <Box className={getRootStyle()}>
      <Box className={classes.toolbarLeft}>
        <Box display="inline-block" mr={2} style={{ verticalAlign: "middle" }}>
          <MindfileAvatar />
        </Box>
        <Box display="inline-block" mr={2} style={{ verticalAlign: "middle" }}>
          {mindfile.id ? renderMindfileSelector() : ""}
        </Box>
        <Box display="inline-block" style={{alignSelf:'end', whiteSpace:'nowrap'}} >{renderNotificationsToggle()}</Box>
      </Box>
      <CreateMindfileForm open={isCreateMindfileOpen} closeModal={() => setIsCreateMindfileOpen(false)} />
      <Modal
        id="notificationsDialog"
        className={classes.modal}
        open={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
      >
        <NotificationsList closeModal={() => setIsNotificationsOpen(false)} />
      </Modal>
      <Dialog
        PaperProps={{id:"contribRequestDialog"}}
        open={isContributorRequestOpen}
        onClose={() => setIsContributorRequestOpen(false)}
      >
        <DialogTitle>Request to Become a Contributor</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your request has been sent. You will be notified when it is accepted
            or rejected.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setIsContributorRequestOpen(false)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const mapStateToProps = state => ({
  user: state.auth,
  mindfile: state.mindfile,
  mindfiles: state.mindfiles,
});

const mapDispatchToProps = {
  getMindfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(MindfileBar);
